import React from "react";
import { observer } from "mobx-react-lite";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../components/index";
import { Grid, Typography } from "@mui/material";
import { Page } from "../../components";

const Main = observer(() => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Page title="Головна">
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ textAlign: "center", marginTop: 1 }}>
            <Typography>
              Для входу в особистий кабінет співробітника університету виберіть пункт меню «Авторизація»
              <br />
              Якщо Ви вперше на сайті - Вам необхідно зареєструватися в єдиній електронній системі системі університету.
              Для реєстрації натисніть кнопку «Реєстрація»
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ textAlign: "center", marginTop: 5 }}>
            <Typography>
              Для роботи з платформою прочитайте інструкцію, натиснувши на кнопку «Інструкція». Якщо у вас виникли якісь
              проблеми, напишіть у нашу тех. підтримку. Форма для зв'язку знаходиться в розділі «Контакти»
            </Typography>
          </Grid>
        </Grid>
      </Page>
    </ErrorBoundary>
  );
});


export default Main;
